import pimg1 from '../images/allimg/chalet/1.webp';
import pimg2 from '../images/allimg/chalet/2.webp';
import pimg3 from '../images/allimg/chalet/3.webp';
import pimg4 from '../images/allimg/chalet/4.webp';
import pimg5 from '../images/allimg/chalet/5.webp';
import pimg6 from '../images/allimg/chalet/6.webp';
import pimg7 from '../images/allimg/chalet/7.webp';
import pimg8 from '../images/allimg/chalet/8.webp';
import pimg9 from '../images/allimg/chalet/9.webp';
import pimg10 from '../images/allimg/chalet/10.webp';
import pimg11 from '../images/allimg/chalet/11.webp';
import pimg12 from '../images/allimg/chalet/12.webp';
import pimg133 from '../images/allimg/chalet/13.webp';
import pimg14 from '../images/allimg/chalet/h1.webp';
import pimg15 from '../images/allimg/chalet/h2.webp';
import pimg16 from '../images/allimg/chalet/h3.webp';
import pimg17 from '../images/allimg/chalet/h4.webp';
import pimg18 from '../images/allimg/chalet/h5.webp';
import pimg19 from '../images/allimg/chalet/h6.webp';
import ps1img1 from '../images/project-single/1.jpg';
import ps1img2 from '../images/project-single/2.jpg';
import ps1img3 from '../images/project-single/3.jpg';
import ps1img4 from '../images/project-single/4.jpg';
import ps1img5 from '../images/project-single/5.jpg';
import ps1img6 from '../images/project-single/6.jpg';
import ps1img7 from '../images/project-single/7.jpg';
import ps1img8 from '../images/project-single/8.jpg';
import ps1img9 from '../images/project-single/9.jpg';
import ps1img10 from '../images/project-single/10.jpg';
import psub1img1 from '../images/project-single/p1.jpg';
import psub1img2 from '../images/project-single/p2.jpg';

const Chalet = [
    
    {
        Id: '2',
        pImg: pimg2,
        ps1img: ps1img2,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'GARDEN VILLA',
        subTitle: 'Garden Paradise',
    },
    {
        Id: '3',
        pImg: pimg3,
        ps1img: ps1img3,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'COTTAGE HOUSE',
        subTitle: 'Charming Countryside Cottage',
    },
    {
        Id: '4',
        pImg: pimg4,
        ps1img: ps1img4,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'HILL TOP VILLA',
        subTitle: 'Spectacular Hilltop Views',
    },
    {
        Id: '5',
        pImg: pimg5,
        ps1img: ps1img5,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'SUNRISE HOME',
        subTitle: 'Enjoy Morning Bliss',
    },
    {
        Id: '6',
        pImg: pimg6,
        ps1img: ps1img6,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'CHALET LABONNE',
        subTitle: 'Rustic Chalet Escape',
    },
    {
        Id: '7',
        pImg: pimg7,
        ps1img: ps1img7,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'VIEWPOINT OASIS',
        subTitle: 'Breathtaking Views',
    },
    {
        Id: '8',
        pImg: pimg8,
        ps1img: ps1img8,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'INTERIOR',
        subTitle: 'Modern Interior Design',
    },
    {
        Id: '9',
        pImg: pimg9,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    {
        Id: '10',
        pImg: pimg10,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    {
        Id: '11',
        pImg: pimg11,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    
   
    {
        Id: '14',
        pImg: pimg14,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    {
        Id: '15',
        pImg: pimg15,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    {
        Id: '16',
        pImg: pimg16,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    {
        Id: '17',
        pImg: pimg17,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    {
        Id: '18',
        pImg: pimg18,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    {
        Id: '12',
        pImg: pimg12,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    {
        Id: '19',
        pImg: pimg19,
        ps1img: ps1img9,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    {
        Id: '13',
        pImg: pimg133,
        psub1img1: psub1img1,
        psub1img2: psub1img2,
        title: 'ARCHITECTURE',
        subTitle: 'Innovative Architecture Design',
    },
    
];

export default Chalet;
